import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

const CustomTabs = ({ tabOptions = [], selectedValue = "", onChange }) => {
  return (
    <Box>
      <Tabs
        value={selectedValue}
        onChange={(e, newValue) => onChange?.(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
      >
        {tabOptions.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTabs;
